import React from 'react';
import { FadeIn } from './Shared';
export const StatsBar = () => {
  const stats = [{
    value: '+800',
    label: 'Mujeres ya lo están usando'
  }, {
    value: '4.9/5',
    label: 'Valoración promedio'
  }, {
    value: '+60',
    label: 'Estrategias prácticas'
  }, {
    value: '#1',
    label: 'Método en bienestar digestivo'
  }];
  return <div className="bg-sage-800 text-white py-12" data-id="element-150">
      <div className="max-w-6xl mx-auto px-6 md:px-8" data-id="element-151">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center divide-x-0 md:divide-x divide-sage-600/50" data-id="element-152">
          {stats.map((stat, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-153">
              <div className="flex flex-col items-center justify-center px-4" data-id="element-154">
                <span className="text-3xl md:text-4xl font-serif font-bold text-sage-200 mb-2" data-id="element-155">
                  {stat.value}
                </span>
                <span className="text-sm md:text-base text-sage-100/80 font-medium max-w-[150px]" data-id="element-156">
                  {stat.label}
                </span>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
};